import React, { useEffect, useState } from "react";
import { 
    Container, 
    Grid, 
    CircularProgress,
    Alert
} from "@mui/material";
import { Add as AddIcon, AdminPanelSettings } from "@mui/icons-material";
import { BasicButton } from "../../../../components/BasicButton";
import { PortalScreenHeader } from "../../../../components/PortalScreenHeader";
import { roleManagementStore } from "../../../../app/stores/RoleManagement";
import { RoleManagementService } from "../../../../services/supabase/RoleManagementService";
import { RolesTable } from "./components/RolesTable";
import { CreateRoleDialog } from "./components/CreateRoleDialog";
import { PermissionWrapper } from "../../../../components/PermissionWrapper";

const Roles: React.FC = () => {
    const {
        roles,
        isLoading,
        error,
        clearError
    } = roleManagementStore();

    const [showCreateDialog, setShowCreateDialog] = useState(false);

    useEffect(() => {
        // Call service functions directly to avoid infinite loops
        RoleManagementService().getAllRoles();
        RoleManagementService().getAllScreens();
    }, []); // Empty dependency array - only run once on mount

    const handleCreateRole = () => {
        setShowCreateDialog(true);
    };

    const handleCloseDialogs = () => {
        clearError();
        setShowCreateDialog(false);
    };

    return (
        <PermissionWrapper screen="roles" permission="view">
            <Container
                component="main"
                maxWidth="xl"
                sx={{
                    height: "100%",
                    paddingX: { xs: 0, md: 2 },
                }}>
                {
                    isLoading && roles.length === 0 ?
                        <Grid container justifyContent="center" mt={20}>
                            <Grid item>
                                <CircularProgress />
                            </Grid>
                        </Grid>
                        :
                        <>
                            <PortalScreenHeader
                                title="Role Management"
                                subtitle="Configure roles and permissions"
                                icon={<AdminPanelSettings />}
                                mobileActionIcon={<AddIcon />}
                                onMobileActionClick={handleCreateRole}
                                actions={
                                    <PermissionWrapper screen="roles" permission="create">
                                        <BasicButton
                                            title="Create Role"
                                            onClick={handleCreateRole}
                                            startIcon={<AddIcon />}
                                        />
                                    </PermissionWrapper>
                                }
                            />

                            {error && (
                                <Alert severity="error" sx={{ mb: 3 }} onClose={clearError}>
                                    {error}
                                </Alert>
                            )}

                            <RolesTable
                                roles={roles}
                            />

                            {/* Create Role Dialog */}
                            <CreateRoleDialog
                                open={showCreateDialog}
                                onClose={handleCloseDialogs}
                            />
                        </>
                }
            </Container>
        </PermissionWrapper>
    );
};

export default Roles; 